import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { Box } from '@mui/material'
import { Autocomplete } from '@/components/inputs/Autocomplete/Autocomplete'
import { useMarketTypesStore } from '@/stores/golfPricing/marketTypes.store'

import { TypeOption } from '../types'

type MarketTypeSelectorProps = {
  value: TypeOption | null
  onChange: (value: TypeOption | null) => void
}

const parseLabel = (label: string): string => {
  return label.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export const MarketTypeSelector = ({ value, onChange }: MarketTypeSelectorProps) => {
  const {
    data: marketTypes,
    fetchData: fetchMarketTypes,
    resetState: resetMarketTypesState
  } = useMarketTypesStore(
    useShallow((state) => ({
      data: state.data,
      fetchData: state.fetchData,
      resetState: state.resetState
    }))
  )

  const marketTypeOptions =
    marketTypes?.map((marketType) => ({
      value: marketType.name,
      label: marketType.name
    })) || []

  useEffect(() => {
    fetchMarketTypes()
    return () => {
      resetMarketTypesState()
    }
  }, [fetchMarketTypes, resetMarketTypesState])

  return (
    <Box sx={{ flex: '1 1 200px', minWidth: '150px' }}>
      <Autocomplete
        label="Market Type"
        options={marketTypeOptions}
        value={value}
        onChange={onChange}
        getOptionLabel={(option) => parseLabel(option.label)}
        multiselect={false}
        required
      />
    </Box>
  )
}
